import { ShareType } from './data'
import { ISEOContext } from 'constants/types/common.types'

const generateSocialLinks = (data: ISEOContext) => {
  const title = encodeURIComponent(data.TITLE || '')
  const description = encodeURIComponent(data.DESCRIPTION || '')
  const isWithQuestionMark = data?.LINK?.includes('?')

  const baseLink = `${isWithQuestionMark ? '&' : '?'}utm_medium=share&utm_campaign=${
    data.type || ''
  }&utm_content=${data.id || ''}`
  const vkLink = encodeURIComponent(`${data.LINK}${baseLink}&utm_source=vk`)
  const odnoklLink = encodeURIComponent(`${data.LINK}${baseLink}&utm_source=ok`)
  // const fbLink = encodeURIComponent(`${data.LINK}${baseLink}&utm_source=fb`)
  const telegLink = encodeURIComponent(`${data.LINK}${baseLink}&utm_source=tg`)
  const whatsAppLink = encodeURIComponent(`${data.LINK}${baseLink}&utm_source=whatsapp`)

  return {
    [ShareType.VK]: `http://vk.com/share.php?url=${vkLink}&title=${title}&description=${description}&image=${data.IMG}&noparse=true`,
    [ShareType.ODNOKL]: `https://connect.ok.ru/offer?url=${odnoklLink}&title=${title}&imageUrl=${data.IMG}`,
    // [ShareType.FB]: `https://www.facebook.com/sharer/sharer.php?u=${fbLink}&src=share_button`,
    [ShareType.TELEGRAM]: `https://telegram.me/share/url?url=${telegLink}&text=${title}`,
    [ShareType.WHATSAPP]: `https://api.whatsapp.com/send?text=${whatsAppLink}`,
  }
}

export { generateSocialLinks }
